// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-wrap-pre-line[data-v-956b2d16]{white-space:pre-line}ul[data-v-956b2d16]{color:#b9bdcc;font-size:16px}", ""]);
// Exports
module.exports = exports;
